// PDFJS depends implicitly on a global Buffer variable to be defined.
// Once this is fixed, this line can be removed.
// In the future, it might be a good idea to wrap pdfjs-dist in our own facade library that abstracts this away.
import { Buffer } from 'buffer';
globalThis.Buffer = Buffer;
import './main.css';
export * from './lib/new-reader';
export * from './lib/constants';
